import { render } from "./DetalleEvaluaciones.vue?vue&type=template&id=92a1cdae"
import script from "./DetalleEvaluaciones.vue?vue&type=script&lang=js"
export * from "./DetalleEvaluaciones.vue?vue&type=script&lang=js"

import "./DetalleEvaluaciones.vue?vue&type=style&index=0&id=92a1cdae&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__